import { SpiceLevel } from 'common/SpiceLevels';
import { match } from 'ts-pattern';
import { Icon, IconColor, IconSize } from 'web-common/src/shared/design-system/components/Icon';

interface SpiceTagProps {
  spiceLevel: SpiceLevel;
  size?: IconSize;
}

export const SpiceTag: React.FC<SpiceTagProps> = ({ spiceLevel, size = 16 }) => {
  if (spiceLevel === SpiceLevel.NOT_SPICY) {
    return <Icon name='restrictionSpicyPepper' size={size} color={IconColor.EGGPLANT_500} />;
  }

  const pepperCount = match(spiceLevel)
    .with(SpiceLevel.MILD, () => 1)
    .with(SpiceLevel.MEDIUM, () => 2)
    .with(SpiceLevel.HOT, () => 3)
    .otherwise(() => 0);

  return (
    <div className='flex items-center'>
      {Array.from({ length: pepperCount }).map((_, index) => (
        <Icon key={index} name='spicyPepper' size={size} color={IconColor.EGGPLANT_500} />
      ))}
    </div>
  );
};
